import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu'];

  connect() {
    this._onDocumentClick = (event) => {
      if (!this.element.contains(event.target)) this.close();
    };
    this._onKeydown = (event) => {
      if (event.key === 'Escape') this.close();
    };
  }

  toggle(event) {
    event.stopPropagation();
    if (this.menuTarget.classList.contains('is-open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.menuTarget.classList.add('is-open');
    document.addEventListener('click', this._onDocumentClick);
    window.addEventListener('keydown', this._onKeydown);
  }

  close() {
    this.menuTarget.classList.remove('is-open');
    document.removeEventListener('click', this._onDocumentClick);
    window.removeEventListener('keydown', this._onKeydown);
  }

  disconnect() {
    document.removeEventListener('click', this._onDocumentClick);
    window.removeEventListener('keydown', this._onKeydown);
  }
}
